import { render, staticRenderFns } from "./MobileSectionSliderNewCopy.vue?vue&type=template&id=181774fa&scoped=true&"
import script from "./MobileSectionSliderNewCopy.vue?vue&type=script&lang=js&"
export * from "./MobileSectionSliderNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./MobileSectionSliderNewCopy.vue?vue&type=style&index=0&id=181774fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181774fa",
  null
  
)

export default component.exports